"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { forwardRef } from "react";
import Tooltip from "../Tooltip/Tooltip";
import { Text } from "../Text/Text";
import { Tick } from "../../icons";
import classNames from "classnames";
import * as styles from "./MenuItem-css";
import { Transition } from "react-transition-group";
import { forceReflow } from "../../../utils";
import { duration } from "../../../tokens/tokens-css";
const menuItemLabelSize = /* @__PURE__ */ new Map([
  ["m", "s"],
  ["s", "s"],
  ["xs", "xs"]
]);
export const MenuItem = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      startElement,
      endElement,
      selected,
      active,
      role,
      multiselect,
      size = "m",
      strong,
      destructive,
      className,
      disabled,
      tooltip,
      truncate,
      href,
      target,
      rel
    } = _b, rest = __objRest(_b, [
      "children",
      "startElement",
      "endElement",
      "selected",
      "active",
      "role",
      "multiselect",
      "size",
      "strong",
      "destructive",
      "className",
      "disabled",
      "tooltip",
      "truncate",
      "href",
      "target",
      "rel"
    ]);
    const buttonRole = role || getMenuItemRole(selected, multiselect);
    const Element = href ? "a" : "button";
    const linkProps = href ? {
      href,
      target: target || href.includes("://") ? "_blank" : void 0,
      rel: rel || "noopener noreferrer"
    } : {};
    const content = /* @__PURE__ */ React.createElement(
      Element,
      __spreadValues(__spreadValues({
        className: classNames(styles.container({ active, size, destructive }), className),
        "aria-current": active,
        role: buttonRole,
        type: href ? void 0 : "button",
        ref,
        disabled,
        "aria-disabled": disabled,
        "aria-checked": !!buttonRole && ["menuitemcheckbox", "menuitemradio"].includes(buttonRole) ? selected : void 0,
        "aria-selected": buttonRole === "option" ? selected : void 0
      }, linkProps), rest),
      !!startElement && /* @__PURE__ */ React.createElement("div", { className: styles.element }, startElement),
      /* @__PURE__ */ React.createElement(
        Text,
        {
          truncate,
          className: styles.label,
          size: menuItemLabelSize.get(size),
          lineHeight: "compact",
          strong
        },
        children
      ),
      !!endElement && /* @__PURE__ */ React.createElement("div", { className: styles.element }, endElement),
      selected !== void 0 && /* @__PURE__ */ React.createElement("div", { className: styles.selection }, /* @__PURE__ */ React.createElement(Transition, { mountOnEnter: true, unmountOnExit: true, in: selected, onEnter: forceReflow, timeout: duration.s }, (status) => /* @__PURE__ */ React.createElement(Tick, { className: styles.tick({ visible: ["entering", "entered"].includes(status) }) })))
    );
    if (tooltip) {
      return /* @__PURE__ */ React.createElement(Tooltip, __spreadValues({}, tooltip), content);
    }
    return content;
  }
);
function getMenuItemRole(selected, multi) {
  if (selected === void 0)
    return void 0;
  if (multi)
    return "menuitemcheckbox";
  return "menuitemradio";
}
